import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rgba } from 'polished';
import screen from 'superior-mq';
import objectPath from 'object-path';
import Subhead from '../../subhead';
import Container from '../../container';
import Waves from '../../waves';
import HeroTextWave from '../../hero-text-wave';

const ProgramHero = ({ subheading, title, location, image }) => {
  const heroImage = objectPath.has(image, 'file.url')
    ? `${image.file.url}?w=1920&h=1080&q=90&fm=jpg&fl=progressive`
    : `${process.env.S3_ROOT}/w4w-static/images/w4w_hero_placeholder.jpg`;

  return (
    <Hero>
      <Waves
        animateIn
        position="bottom"
        alignment="bottom"
        height={222}
      />
      <Container>
        <HeroTextWave>
          <Subhead>{subheading}</Subhead>
        </HeroTextWave>
        <HeroTextWave>
          <h1>{title}</h1>
        </HeroTextWave>
        <HeroTextWave>
          <h4>{location}</h4>
        </HeroTextWave>
      </Container>

      <HeroImage>
        <img
          src={heroImage}
          alt={image ? image.description : title}
        />
      </HeroImage>
    </Hero>
  );
};

const Hero = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: #fff;

  h1 {
    margin: 0 auto 25px;
    max-width: 1000px;
  }

  ${screen.above(bp.portrait, `
    height: ${(9 / 16) * 100}vw;
  `)};

  ${screen.below(bp.portrait, `
    padding: 100px 0;
  `)};
`;

const HeroImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${props => `linear-gradient(180deg, ${rgba(props.theme.blue, 1)}, ${rgba(props.theme.blue, 0)})`};
    z-index: 1;
    mix-blend-mode: multiply;
  }
`;

ProgramHero.propTypes = {
  title: PropTypes.string,
  location: PropTypes.string,
  subheading: PropTypes.string,
  image: PropTypes.object,
};

export default ProgramHero;
